import axios from "../http";

let module = "/classRoom";

function selectAllClassRoom() {
    return axios.get(module);
}

function updateClassRoom(data) {
    return axios.put(module, data);
}
function selectClassRoom(data) {
    return axios.post(module,data);
}

export default {
    updateClassRoom,selectClassRoom,selectAllClassRoom
}
